module.exports = __webpack_public_path__ + "static/media/user-profile.2194ec9c.svg";